
import React, { useState } from 'react';
const mentors = [
  { role: 'AI Engineer', desc: 'LLM applications, agents, RAG' },
  { role: 'Data Scientist', desc: 'ML pipelines, MLOps' },
  { role: 'Cloud Architect', desc: 'DevOps, infra as code' },
];

export default function Mentors() {
  return (
    <section id="mentors" className="max-w-7xl mx-auto px-4 py-12">
      <h2 className="text-2xl md:text-3xl font-bold">Meet the Mentors Shaping Your Future</h2>
      <p className="mt-2 text-slate-600 dark:text-slate-300">Guidance toward mastery & growth opportunities.</p>

      <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {mentors.map(m => (
          <article key={m.role} className="mentor-card reveal">
            <div className="mentor-avatar" />
            <div className="p-5">
              <h3 className="font-semibold">{m.role}</h3>
              <p className="text-sm text-slate-600 dark:text-slate-300">{m.desc}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
